import _ from "lodash";
import React from "react";
import classes from "./Header.scss";
import { TickPlain, ChevronIcon } from "SvgComponents";
import { colors } from "Constants";
import I18nHOC from "UIComponents/I18nHOC";
import UIButton from "UIComponents/UIButton";
import classNames from "classnames";
import { isPortfolioParityEnabled } from "Post/utils";
import { Button } from "@toddle-edu/ds-web";
import { TickCircleFilled } from "@toddle-edu/ds-icons";

class Header extends React.PureComponent {
  render() {
    const {
      onBackClick,
      isDoneDisabled = false,
      showTimer,
      timer,
      isRecordingPaused,
      onDoneClick,
      t,
      title,
      showTitle = false,
      showCustomHeaderIcon = false,
      customHeaderIcon,
      headerTextStyle,
      headerContainerStyle = {},
      flipCamera,
      showFlipCamera = false,
    } = this.props;

    const doneButtonStyle = !isDoneDisabled
      ? {
          borderRadius: 20,
          backgroundColor: colors.blue400,
          borderWidth: 0,
        }
      : { borderRadius: 20, borderWidth: 0 };

    const timerContainerClass = classNames({
      [classes.timerContainer]: true,
      [classes.darkTimerContainer]:
        isRecordingPaused && !isPortfolioParityEnabled(),
    });

    const container = classNames({
      [classes.container]: true,
      [classes.darkContainer]: isRecordingPaused && !isPortfolioParityEnabled(),
    });

    return (
      <div className={container} style={headerContainerStyle}>
        <div className={classes.leftContainer}>
          <div className={classes.backContainer} onClick={onBackClick}>
            <div className={classes.chevronIconContainer}>
              <ChevronIcon />
            </div>
            {showCustomHeaderIcon && (
              <div className={classes.customIcon}>{customHeaderIcon}</div>
            )}
            <div style={headerTextStyle} className={classes.backButtonText}>
              {showTitle ? title : t("common:back")}
            </div>
          </div>
        </div>
        {showTimer && (
          <div
            className={classes.centerContainer}
            style={{ paddingRight: isPortfolioParityEnabled() ? "8%" : "" }}
          >
            <div className={timerContainerClass}>
              {!isRecordingPaused && <div className={classes.redDot}></div>}
              <div className={classes.timerText}>{timer}</div>
            </div>
          </div>
        )}
        <div className={classes.rightContainer}>
          {isPortfolioParityEnabled() ? (
            <>
              <Button
                size="large"
                variant="progressive"
                onClick={onDoneClick}
                disabled={isDoneDisabled}
                icon={<TickCircleFilled variant={"on"} size={"xx-small"} />}
              >
                {t("common:done")}
              </Button>
              {showFlipCamera && !_.isUndefined(flipCamera) ? flipCamera : null}
            </>
          ) : (
            <UIButton
              isDisabled={isDoneDisabled}
              containerStyle={{ ...doneButtonStyle }}
              onClick={onDoneClick}
              size="sm"
            >
              <div className={classes.tickIconContainer}>
                <TickPlain width={16} height={11} />
              </div>
              <div className={classes.buttonText}>{t("common:done")}</div>
            </UIButton>
          )}
        </div>
      </div>
    );
  }
}

export default I18nHOC({ resource: "common" })(Header);
